import Avatar from '@material-ui/core/Avatar';
import { useRecordContext } from 'react-admin';

const AvatarField = (props) => {
    const record = useRecordContext();
    const size = props.size;
    return record ? (
        <div className={`avatarField${props.className ? ` ${props.className}` : ""}`}>
            <Avatar
                src={`${record[props.avatarSource]}`}
                style={{ width: parseInt(size, 10), height: parseInt(size, 10) }}
            />
            {props.source && <span>{record[props.source]}</span>}
        </div>
    ) : null;
};

AvatarField.defaultProps = {
    size: 25,
    avatarSource: "avatar"
};

export default AvatarField;